import { PrimeReactProvider } from 'primereact/api';
import Router from './router'
import { BrowserRouter } from 'react-router-dom';
import { MenuProvider } from './Hooks/menubarItems';

function App() {

  return (
    <PrimeReactProvider>
      <BrowserRouter basename={""}>
        <MenuProvider>
          <Router />
        </MenuProvider>
      </BrowserRouter>
    </PrimeReactProvider>
  )
}

export default App
